import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const Shop = forwardRef(
    ({ color = "currentColor", size = 24, ...rest }, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                {...rest}
            >
                <path d="M2.5 16.5v.5h12.25v-4.25a.25.25 0 01.5 0V23h5c.69 0 1.25-.56 1.25-1.25v-9a.25.25 0 01.5 0v9c0 .965-.785 1.75-1.75 1.75H3.75c-.965 0-1.75-.785-1.75-1.75v-9a.25.25 0 01.5 0v3.75zM14.25 23h.5v-5.5H2.5v4.25c0 .69.56 1.25 1.25 1.25h10.5zM19.124 9.15l-.374-.422-.374.423A2.52 2.52 0 0116.5 10a2.52 2.52 0 01-1.876-.85l-.374-.422-.374.423A2.52 2.52 0 0112 10a2.52 2.52 0 01-1.876-.85l-.374-.422-.374.423A2.52 2.52 0 017.5 10a2.52 2.52 0 01-1.876-.85l-.374-.422-.374.423A2.52 2.52 0 013 10 2.504 2.504 0 01.5 7.5c0-.017.002-.034.006-.054h0l1.369-6.163s0 0 0 0A.993.993 0 012.852.5h18.295c.464 0 .877.331.977.783h0l1.37 6.163h0v.003a.23.23 0 01.006.051c0 1.378-1.122 2.5-2.5 2.5a2.52 2.52 0 01-1.876-.85zM22.997 7.6l.004-.068-.015-.065-1.35-6.074L21.55 1H2.451l-.087.392-1.35 6.074-.015.065.004.068A2.008 2.008 0 003 9.5c1.103 0 2-.897 2-2a.25.25 0 01.5 0c0 1.103.897 2 2 2s2-.897 2-2a.25.25 0 01.5 0c0 1.103.897 2 2 2s2-.897 2-2a.25.25 0 01.5 0c0 1.103.897 2 2 2s2-.897 2-2a.25.25 0 01.5 0c0 1.103.897 2 2 2a2.008 2.008 0 001.997-1.901z"></path>
            </svg>
        );
    }
);

Shop.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Shop.displayName = "Shop";

export default Shop;
